import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const TitleResultPage = ({ target, type }) => {

const [targetMap, setTargetMap] = useState("");
const mapData = require('../../map_gene_pro.json');
const [mapType, setMapType] = useState();
const [entry, setEntry] = useState();


// Setting UniProt hyperlink
useEffect(() => {

    let mappedValue = '';

    const targetItem = mapData.find(item => item.PROTEIN_AN === target.split('_')[0] || item.GENE_SYMBOL === target.split('_')[0]);

    if (targetItem) {
      if (target.split('_')[0] === targetItem.PROTEIN_AN) {
        mappedValue = targetItem.GENE_SYMBOL;
        setMapType('Gene:');
        setEntry(target.split('_')[0]);

      } else if (target.split('_')[0] === targetItem.GENE_SYMBOL) {
        mappedValue = targetItem.PROTEIN_AN;
        setMapType('UniProtKB:');
        setEntry(mappedValue.split('_')[0]);
      }
    }

    setTargetMap(mappedValue);

}, [target, mapData]);


  return (
<>
  <div className="row mb-4">
            <div className="col-12">
             <h1 className="display-5 fw-bold title-explore mb-3">
              {target}
              {type === "gene" && (
                <img
                  alt="logo"
                  src="/assets/images/dna.png"
                  className="img-fluid btn-img"
                  style={{ verticalAlign: 'middle' }}
                />
              )}
              {type === "protein" && (
                <img
                  alt="logo"
                  src="/assets/images/protein.png"
                  className="img-fluid btn-img"
                  style={{ verticalAlign: 'middle' }}
                />
              )}
              { (type === "residue" || type === "gene_residue")&& (
                <img
                  alt="logo"
                  src="/assets/images/chemist.png"
                  className="img-fluid btn-img"
                  style={{ verticalAlign: 'middle' }}
                />
              )}
              <span className="fs--1 align-below" tooltip="UniProt hyperlink">
              <Link to={`https://www.uniprot.org/uniprotkb/${entry}/entry`} target="_blank" rel="noopener noreferrer">
              {mapType}{targetMap} </Link></span>
            </h1>
            </div>
          </div>
</>
  )
}

export default TitleResultPage